import Store from '@/base/constants/Store'

export const IosCategory = Object.freeze({
  OVERALL: { id: '36', name: 'All Categories' },
  BUSINESS: { id: '6000', name: 'Business' },
  WEATHER: { id: '6001', name: 'Weather' },
  UTILITIES: { id: '6002', name: 'Utilities' },
  TRAVEL: { id: '6003', name: 'Travel' },
  SPORTS: { id: '6004', name: 'Sports' },
  SOCIAL_NETWORKING: { id: '6005', name: 'Social Networking' },
  REFERENCE: { id: '6006', name: 'Reference' },
  PRODUCTIVITY: { id: '6007', name: 'Productivity' },
  PHOTO_VIDEO: { id: '6008', name: 'Photo & video' },
  NEWS: { id: '6009', name: 'News' },
  NAVIGATION: { id: '6010', name: 'Navigation' },
  MUSIC: { id: '6011', name: 'Music' },
  LIFESTYLE: { id: '6012', name: 'Lifestyle' },
  HEALTH_FITNESS: { id: '6013', name: 'Health & Fitness' },
  GAMES: { id: '6014', name: 'Games' },
  FINANCE: { id: '6015', name: 'Finance' },
  ENTERTAINMENT: { id: '6016', name: 'Entertainment' },
  EDUCATION: { id: '6017', name: 'Education' },
  BOOKS: { id: '6018', name: 'Books' },
  MEDICAL: { id: '6020', name: 'Medical' },
  MAGAZINES_NEWSPAPERS: { id: '6021', name: 'Magazines & Newspapers' },
  CATALOGS: { id: '6022', name: 'Catalogs' },
  FOOD_DRINK: { id: '6023', name: 'Food & Drink' },
  SHOPPING: { id: '6024', name: 'Shopping' },
  STICKERS: { id: '6025', name: 'Stickers' },
  DEVELOPER_TOOLS: { id: '6026', name: 'Developer Tools' },
  GRAPHICS_DESIGN: { id: '6027', name: 'Graphics & Design' },
  KIDS: { id: '0', name: 'Kids' },
})

export const IosSubCategory = Object.freeze({
  KIDS_OVERALL: { id: IosCategory.KIDS.id, name: 'Kids Overall', parent: IosCategory.KIDS.id },
  KIDS_UNDER_5: { id: '10000', name: 'Under 5', parent: IosCategory.KIDS.id },
  KIDS_6_8: { id: '10001', name: '6 - 8', parent: IosCategory.KIDS.id },
  KIDS_UP_9: { id: '10002', name: '9 Up', parent: IosCategory.KIDS.id },
  GAME: { id: IosCategory.GAMES.id, name: 'Game Overall', parent: IosCategory.GAMES.id },
  GAME_ACTION: { id: '7001', name: 'Action', parent: IosCategory.GAMES.id },
  GAME_ADVENTURE: { id: '7002', name: 'Adventure', parent: IosCategory.GAMES.id },
  GAME_BOARD: { id: '7004', name: 'Board', parent: IosCategory.GAMES.id },
  GAME_CARD: { id: '7005', name: 'Card', parent: IosCategory.GAMES.id },
  GAME_CASINO: { id: '7006', name: 'Casino', parent: IosCategory.GAMES.id },
  GAME_CASUAL: { id: '7003', name: 'Casual', parent: IosCategory.GAMES.id },
  GAME_DICE: { id: '7007', name: 'Dice', parent: IosCategory.GAMES.id },
  GAME_EDUCATIONAL: { id: '7008', name: 'Educational', parent: IosCategory.GAMES.id },
  GAME_FAMILY: { id: '7009', name: 'Family', parent: IosCategory.GAMES.id },
  GAME_MUSIC: { id: '7011', name: 'Music', parent: IosCategory.GAMES.id },
  GAME_PUZZLE: { id: '7012', name: 'Puzzle', parent: IosCategory.GAMES.id },
  GAME_RACING: { id: '7013', name: 'Racing', parent: IosCategory.GAMES.id },
  GAME_ROLE_PLAYING: { id: '7014', name: 'Role Playing', parent: IosCategory.GAMES.id },
  GAME_SIMULATION: { id: '7015', name: 'Simulation', parent: IosCategory.GAMES.id },
  GAME_SPORTS: { id: '7016', name: 'Sports', parent: IosCategory.GAMES.id },
  GAME_STRATEGY: { id: '7017', name: 'Strategy', parent: IosCategory.GAMES.id },
  GAME_TRIVIA: { id: '7018', name: 'Trivia', parent: IosCategory.GAMES.id },
  GAME_WORD: { id: '7019', name: 'Word', parent: IosCategory.GAMES.id },
})

export const PlayCategory = Object.freeze({
  OVERALL: { id: '26', name: 'All Categories' },
  BOOKS_AND_REFERENCE: { id: '0', name: 'Books And Reference' },
  BUSINESS: { id: '1', name: 'Business' },
  COMICS: { id: '2', name: 'Comics' },
  COMMUNICATION: { id: '3', name: 'Communication' },
  EDUCATION: { id: '4', name: 'Education' },
  ENTERTAINMENT: { id: '5', name: 'Entertainment' },
  FINANCE: { id: '6', name: 'Finance' },
  HEALTH_AND_FITNESS: { id: '7', name: 'Health And Fitness' },
  LIBRARIES_AND_DEMO: { id: '8', name: 'Libraries And Demo' },
  LIFESTYLE: { id: '9', name: 'Lifestyle' },
  MEDICAL: { id: '12', name: 'Medical' },
  MUSIC_AND_AUDIO: { id: '13', name: 'Music And Audio' },
  NEWS_AND_MAGAZINES: { id: '14', name: 'News And Magazines' },
  PERSONALIZATION: { id: '15', name: 'Personalization' },
  PHOTOGRAPHY: { id: '16', name: 'Photography' },
  PRODUCTIVITY: { id: '17', name: 'Productivity' },
  SHOPPING: { id: '18', name: 'Shopping' },
  SOCIAL: { id: '19', name: 'Social' },
  SPORTS: { id: '20', name: 'Sports' },
  TRAVEL_AND_LOCAL: { id: '22', name: 'Travel And Local' },
  TOOLS: { id: '23', name: 'Tools' },
  WEATHER: { id: '24', name: 'Weather' },
  GAMES: { id: '27', name: 'Games' },
  MAPS_AND_NAVIGATION: { id: '46', name: 'Maps And Navigation' },
  ANDROID_WEAR: { id: '47', name: 'Wear OS by Google' },
  ART_AND_DESIGN: { id: '48', name: 'Art And Design' },
  AUTO_AND_VEHICLES: { id: '49', name: 'Auto And Vehicles' },
  BEAUTY: { id: '50', name: 'Beauty' },
  DATING: { id: '51', name: 'Dating' },
  EVENTS: { id: '52', name: 'Events' },
  HOUSE_AND_HOME: { id: '53', name: 'House And Home' },
  PARENTING: { id: '54', name: 'Parenting' },
  VIDEO_PLAYERS: { id: '55', name: 'Video Players And Editors' },
  FOOD_AND_DRINK: { id: '56', name: 'Food And Drink' },
  FAMILY: { id: '57', name: 'Family' },
})

export const playSubCategory = Object.freeze({
  GAME: { id: PlayCategory.GAMES.id, name: 'Game Overall', parent: PlayCategory.GAMES.id },
  GAME_ACTION: { id: '28', name: 'Action And Adventure', parent: PlayCategory.GAMES.id },
  GAME_ADVENTURE: { id: '29', name: 'Adventure', parent: PlayCategory.GAMES.id },
  GAME_ARCADE: { id: '30', name: 'Arcade', parent: PlayCategory.GAMES.id },
  GAME_BOARD: { id: '31', name: 'Board', parent: PlayCategory.GAMES.id },
  GAME_CARD: { id: '32', name: 'Card', parent: PlayCategory.GAMES.id },
  GAME_CASINO: { id: '33', name: 'Casino', parent: PlayCategory.GAMES.id },
  GAME_CASUAL: { id: '34', name: 'Casual', parent: PlayCategory.GAMES.id },
  GAME_EDUCATIONAL: { id: '35', name: 'Educational', parent: PlayCategory.GAMES.id },
  GAME_MUSIC: { id: '37', name: 'Music', parent: PlayCategory.GAMES.id },
  GAME_PUZZLE: { id: '38', name: 'Puzzle', parent: PlayCategory.GAMES.id },
  GAME_RACING: { id: '39', name: 'Racing', parent: PlayCategory.GAMES.id },
  GAME_ROLE_PLAYING: { id: '40', name: 'Role Playing', parent: PlayCategory.GAMES.id },
  GAME_SIMULATION: { id: '41', name: 'Simulation', parent: PlayCategory.GAMES.id },
  GAME_SPORTS: { id: '42', name: 'Sports', parent: PlayCategory.GAMES.id },
  GAME_STRATEGY: { id: '43', name: 'Strategy', parent: PlayCategory.GAMES.id },
  GAME_TRIVIA: { id: '44', name: 'Trivia', parent: PlayCategory.GAMES.id },
  GAME_WORD: { id: '45', name: 'Word', parent: PlayCategory.GAMES.id },
  FAMILY_OVERALL: { id: PlayCategory.FAMILY.id, name: 'Family Overall', parent: PlayCategory.FAMILY.id },
  FAMILY_ACTION: { id: '58', name: 'Action', parent: PlayCategory.FAMILY.id },
  FAMILY_BRAINGAMES: { id: '59', name: 'Brain Games', parent: PlayCategory.FAMILY.id },
  FAMILY_CREATE: { id: '60', name: 'Creativity', parent: PlayCategory.FAMILY.id },
  FAMILY_EDUCATION: { id: '61', name: 'Education', parent: PlayCategory.FAMILY.id },
  FAMILY_MUSICVIDEO: { id: '62', name: 'Music And Video', parent: PlayCategory.FAMILY.id },
  FAMILY_PRETEND: { id: '63', name: 'Pretend Play', parent: PlayCategory.FAMILY.id },
})

export const playAgeCategory = Object.freeze({
  UP_TO_12: { id: 1, name: 'All ages up to 12' },
  UP_TO_5: { id: 2, name: 'Ages up to 5' },
  AGES_6_TO_8: { id: 3, name: 'Ages 6 to 8' },
  AGES_9_TO_12: { id: 4, name: 'Ages 9 to 12' },
})

export const IOS_PLAY_ID_MATCHES = [
  { [Store.Ios]: IosCategory.OVERALL.id, [Store.Play]: PlayCategory.OVERALL.id },
  { [Store.Ios]: IosCategory.BUSINESS.id, [Store.Play]: PlayCategory.BUSINESS.id },
  { [Store.Ios]: IosCategory.WEATHER.id, [Store.Play]: PlayCategory.WEATHER.id },
  { [Store.Ios]: IosCategory.UTILITIES.id, [Store.Play]: PlayCategory.TOOLS.id },
  { [Store.Ios]: IosCategory.TRAVEL.id, [Store.Play]: PlayCategory.TRAVEL_AND_LOCAL.id },
  { [Store.Ios]: IosCategory.SPORTS.id, [Store.Play]: PlayCategory.SPORTS.id },
  { [Store.Ios]: IosCategory.SOCIAL_NETWORKING.id, [Store.Play]: PlayCategory.SOCIAL.id },
  { [Store.Ios]: IosCategory.REFERENCE.id, [Store.Play]: PlayCategory.BOOKS_AND_REFERENCE.id },
  { [Store.Ios]: IosCategory.PRODUCTIVITY.id, [Store.Play]: PlayCategory.PRODUCTIVITY.id },
  { [Store.Ios]: IosCategory.PHOTO_VIDEO.id, [Store.Play]: PlayCategory.PHOTOGRAPHY.id },
  { [Store.Ios]: IosCategory.NEWS.id, [Store.Play]: PlayCategory.NEWS_AND_MAGAZINES.id },
  { [Store.Ios]: IosCategory.NAVIGATION.id, [Store.Play]: PlayCategory.MAPS_AND_NAVIGATION.id },
  { [Store.Ios]: IosCategory.MUSIC.id, [Store.Play]: PlayCategory.MUSIC_AND_AUDIO.id },
  { [Store.Ios]: IosCategory.LIFESTYLE.id, [Store.Play]: PlayCategory.LIFESTYLE.id },
  { [Store.Ios]: IosCategory.HEALTH_FITNESS.id, [Store.Play]: PlayCategory.HEALTH_AND_FITNESS.id },
  { [Store.Ios]: IosCategory.GAMES.id, [Store.Play]: PlayCategory.GAMES.id },
  { [Store.Ios]: IosCategory.ENTERTAINMENT.id, [Store.Play]: PlayCategory.ENTERTAINMENT.id },
  { [Store.Ios]: IosCategory.EDUCATION.id, [Store.Play]: PlayCategory.EDUCATION.id },
  { [Store.Ios]: IosCategory.BOOKS.id, [Store.Play]: PlayCategory.BOOKS_AND_REFERENCE.id },
  { [Store.Ios]: IosCategory.MEDICAL.id, [Store.Play]: PlayCategory.MEDICAL.id },
  { [Store.Ios]: IosCategory.MAGAZINES_NEWSPAPERS.id, [Store.Play]: PlayCategory.PRODUCTIVITY.id },
  { [Store.Ios]: IosCategory.CATALOGS.id, [Store.Play]: PlayCategory.PRODUCTIVITY.id },
  { [Store.Ios]: IosCategory.FOOD_DRINK.id, [Store.Play]: PlayCategory.FOOD_AND_DRINK.id },
  { [Store.Ios]: IosCategory.SHOPPING.id, [Store.Play]: PlayCategory.SHOPPING.id },
  { [Store.Ios]: IosCategory.STICKERS.id, [Store.Play]: PlayCategory.PRODUCTIVITY.id },
]

export const OVERALL_CATEGORY_IOS_ID = IosCategory.OVERALL.id

export const OVERALL_CATEGORY_PLAY_ID = PlayCategory.OVERALL.id

export const OVERALL_GAMES_IOS_ID = IosCategory.GAMES.id

export const OVERALL_GAMES_PLAY_ID = PlayCategory.GAMES.id

export const OVERALL_KIDS_IOS_ID = IosCategory.KIDS.id

export const OVERALL_FAMILY_PLAY_ID = PlayCategory.FAMILY.id

export const OVERALL_FAMILY_AGE_PLAY_ID = playAgeCategory.UP_TO_12.id
